module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/vi_5-3c8fdfbc4026f9ff9da620f589f39c7d.jpg";